String.prototype.reverse = function ()
{
	return this.split('').reverse().join('');
};

const $properties        = $('#search-second-row').find('.property-wrapper'),
	  $priceInputs       = $("#price-interval_from[value], #price-interval_to[value]"),
	  $search            = $('#search-module'),
	  $searchResetButton = $('.search-reset-btn');

function showObjectIDSearchField(e)
{
	const $firstRow               = $('#search-first-row'),
		  $secondRow              = $('#search-second-row'),
		  $idWrapper              = $(this).parent(),
		  isExtendedSearchVisible = !($('.more-filter-btn').hasClass('hidden'));

	e.preventDefault();

	$(this).hide();

	// Makes field smaller, if extended Search is visible.
	if (isExtendedSearchVisible)
	{
		$idWrapper.closest('.search-control').addClass('extSearch');
	}

	$idWrapper.find('input').fadeIn().removeClass('hidden').focus();

	$firstRow.find('input').prop('disabled', true);
	$firstRow.find('select').prop('disabled', true).trigger("chosen:updated");
	$firstRow.find('.locate-btn').addClass('disabled');

	$secondRow.find('input').prop('disabled', true);
	$secondRow.find('.ctrl').labeledslider('disable');
	$secondRow.find('select').prop('disabled', true).trigger("chosen:updated");
}

function updateFieldsIfIdSearchfieldIsEmpty()
{
	const $firstRow  = $('#search-first-row'),
		  $secondRow = $('#search-second-row'),
		  $areafield = $firstRow.find('.area-field input'),
		  $areaSize  = $firstRow.find('#area-size');

	if (!$(this).val().trim().length)
	{
		$firstRow.find('input').prop('disabled', false);
		$firstRow.find('select').prop('disabled', false).trigger("chosen:updated");

		// This exclusive test is because area-size can initialy be disabled, and must then disabled after, too.
		if (!$areafield.val().trim().length)
		{
			$areaSize.prop('disabled', true).trigger('chosen:updated');
		}

		$firstRow.find('.locate-btn').removeClass('disabled');

		$secondRow.find('input').prop('disabled', false);
		$secondRow.find('.ctrl').labeledslider('enable');
		$secondRow.find('select').prop('disabled', false).trigger("chosen:updated");
	}
}

function openOrCloseExtendedSearchCriterias()
{
	$(this).toggleClass('closed');
	$(this).closest('.estate-search').find('#search-second-row').slideToggle({
		"complete": function ()
		{
			$(window).resize();
		}
	});

	let title = $(this).hasClass('closed') ? 'Weitere Filter einblenden' : 'Weitere Filter ausblenden';

	$(this).attr('title', title);

}

function showMatchingControls(controls)
{
	// container of all extended controls
	const row = $('.dynamic-searchfields');

	// clear old enabled controls
	row.find('.estate-type-relevant').removeClass('estate-type-relevant');

	// iterate over all controls and enable matching ones
	for (let i = 0; i < controls.length; i++)
	{
		row.find('#' + controls[i]).addClass('estate-type-relevant');
	}

	// then show toggle button
	if (row.find('.estate-type-relevant'))
	{
		// ...hide()... is important, otherwise first appearance does not fade anyway.
		$('.more-filter-btn').hide().removeClass('hidden').fadeIn();

		// adding class for some styling later, depending on inputmask has sliders or not.
		$('.id').closest('.search-control').addClass('extSearch');
	}
}

function getMatchingControls(schemaName)
{
	switch (schemaName)
	{
		case 'house_purchase': // Haus kaufen
		case 'houses_rent': // Haus mieten
			return ['estate-type-detail-house-wrapper', 'room-search', 'livingarea-search', 'plotarea-search'];
		case 'flat_purchase': // Wohnung kaufen
		case 'flat_rent': // Wohnung mieten
			return ['estate-type-detail-appartment-wrapper', 'room-search', 'livingarea-search', 'floor-search'];
		// case 'investment': // Renditeobjekt
		// 	return ['xfold-search', 'yearlynetrent-search', 'residentialunits-search', 'commercialunits-search'];
		//
		case 'office_surgery_purchase': // Büro/Praxis kaufen
		case 'office_surgery_rent': // Büro/Praxis mieten
			return ['commercialarea-search'];
		case 'shops_commerce_purchase': // Laden/Handel kaufen
		case 'shops_commerce_rent': // Laden/Handel mieten
			return ['commercialarea-search', 'productionarea-search'];
		case 'production_halls_purchase': // Lager/Halle kaufen
		case 'production_halls_rent': // Lager/Halle mieten
			return ['productionarea-search'];
		case 'other_commercial_estates_purchase': // Sonstige Gew.Immobilie kaufen
		case 'other_commercial_estates_rent': // Sonstige Gew.Immobilie mieten
			return ['commercialarea-search', 'estate-type-detail-commercial'];
		default:
			return [];
	}
}

function setMatchingControls()
{
	// check if a single estate type is chosen or if there are any filters for chosen estate type
	if (!$(this).val() || $(this).val() === '' || !getMatchingControls($(this).val()) || getMatchingControls($(this).val()).length < 1)
	{


		// selected estate type is invalid or empty or has no extened filters, exit.
		$('.more-filter-btn').addClass('closed').fadeOut('fast', function ()
		{
			$(this).addClass('hidden');

			// Object ID search field can get full width now
			$('.id').closest('.search-control').removeClass('extSearch');
		});

		$('#search-second-row').slideUp({
			"complete": function ()
			{
				$(window).resize();
			}
		});
		return;
	}

	// enable matching controls
	showMatchingControls(getMatchingControls($(this).val()));
}

function currencyToGermanCurrencyFormat(number)
{
	const currencyParts = number.toString().replace(".", ",").reverse().match(/\d{1,2},|\d{1,3}/g);
	return currencyParts === null ? number : currencyParts.map(function (e)
	{
		return e.reverse();
	}).reverse().join(".").replace(/\.,/g, ",");
}

function germanCurrencyFormatToCurrency(number)
{
	return number.toString().replace(/\./g, "").replace(",", ".");
}

function resetAndTriggerSearch(e)
{
	const $allChosenSelects      = $search.find('.chosen-select'),
		  $allInputFields        = $search.find('input'),
		  $allSliders            = $search.find('.ctrl'),
		  allChosenSelectsLength = $allChosenSelects.length;

	e.preventDefault();

	// reset all selects to their first value
	for (let i = 0; i < allChosenSelectsLength; i++)
	{
		$allChosenSelects[i].selectedIndex = 0;
	}

	// and update them, cause they are chosen-selects
	$allChosenSelects.trigger('chosen:updated');

	// reset all input fields
	$allInputFields.val('');

	// reset / update sliders
	$allSliders.labeledslider('value', '');

	// trigger search
	$search.submit();
}

$properties.each(function ()
{
	/**
	 * Slider options are set by data-* attr. in search.php:
	 *
	 * data.cid
	 * data.id
	 * data.label
	 * data.max
	 * data.min
	 * data.name
	 * data.interval
	 * data.step
	 * data.isset
	 * data.unit
	 * data.value
	 */
	const $property        = $(this),
		  $sliderContainer = $property.find('.slider-wrapper'),
		  $slider          = $sliderContainer.find('.ctrl'),
		  $input           = $property.find('input'),
		  data             = $property.data(),
		  // for initializing slider and input if user has set a search criteria
		  changedByUser    = data.isset === 1,
		  // calculation of ticks so this library can use it
		  interval         = Math.round((parseInt(data.max, 10) - parseInt(data.min, 10)) / parseInt(data.interval, 10)),
		  // type of slider if min or max
		  type             = ~data.id.indexOf('from') ? 'min' : 'max',
		  // this is the last label of ticks of this slider for later use
		  $lastLabel       = $sliderContainer.find('.ui-slider-labels .ui-slider-label-ticks:last-child span'),
		  // configure slider and attach event handler on slide
		  settings         = {
			  range: type,
			  min: data.min,
			  max: data.max,
			  step: data.step,
			  tickInterval: interval,
			  value:data.value,
			  slide: function (event, ui) {
				  $input.val(ui.value);
			  }
		  };

	// fill with initial data
	$input.val(data.value);

	$slider.labeledslider(settings);

	// overwriting slider and input values if user has changed something
	if (changedByUser)
	{
		$slider.labeledslider('option', 'value', data.value);
		$input.val(data.value);
	}

	// adding event listener for input field to change the slider
	$input.change(function ()
	{
		$slider.labeledslider('value', parseInt(this.value, 10));
	});
});

$priceInputs.each(function ()
{
	$(this).val(currencyToGermanCurrencyFormat($(this).val()));
});

$priceInputs.bind("change blur", function ()
{
	const currentVal = $(this).val(),
		  newVal     = currencyToGermanCurrencyFormat(currentVal);

	if (currentVal !== newVal)
	{
		$(this).val(newVal);
	}
});

$priceInputs.focus(function ()
{
	$(this).val(germanCurrencyFormatToCurrency($(this).val()));
});

// Switches between two price fields depending on "ab / bis" dropdown
$("#price-interval").change(function ()
{
	let fromInput = $("#price-interval_from").first().closest('.text-field'),
		toInput   = $("#price-interval_to").first().closest('.text-field'),
		newValue  = $(this).val();
	//console.log(newValue);
	if (newValue === "from")
	{
		toInput.hide();
		fromInput.show();
		if (toInput.val())
		{
			fromInput.val(toInput.val());
		}
	}
	else if (newValue === "to")
	{
		fromInput.hide();
		toInput.show();
		if (fromInput.val())
		{
			toInput.val(fromInput.val());
		}
	}
	else
	{
		log("Unknown from_to value switcher value: " + newValue);
	}
});

// Allows user to search for an estate id
$('.id a').click(showObjectIDSearchField);

// Shows link-button if user did not enter any id
$('#estate-identifier').blur(updateFieldsIfIdSearchfieldIsEmpty);

// After user chose an estatetype, all neccessary filters get enabled...
const estateTypeId      = "#search-estate-type",
	  $estateTypeSelect = $(estateTypeId),
	  $filterBtn        = $('.more-filter-btn'),
	  frameResizer      = typeof ogrFrameMsg !== 'undefined' && ogrFrameMsg !== null ? ogrFrameMsg : false;

//Whenever you change
$estateTypeSelect.change(setMatchingControls);

let resizeChosenDropdown = function ()
{
	const id       = $(this).attr("id"),
		  //id logic copied from chosen.jquery.js:530
		  chosenId = "#" + id.replace(/[^\w]/g, "_") + "_chosen",
		  dropdown = $(chosenId).find(".chosen-drop"),
		  body     = $("body");
	//We need the delay, because chosen fires the showing_dropdown event before it has put the options into the
	// dropdown. I furthermore think that 100ms are good compromise of usage-delay and time for calculation.
	if (frameResizer)
	{
		setTimeout(() => frameResizer.send(Math.max(dropdown.offset().top + dropdown.outerHeight(), body.height()), false), 100);
	}
};

if (frameResizer)
{
	const bodyHeight = $('body').height();
	$estateTypeSelect.chosen().on("chosen:showing_dropdown", function ()
	{
		resizeChosenDropdown.call(this);
	}).on("chosen:hiding_dropdown", function ()
	{
		$(window).resize();
	});

	$('#area-size')
		.on('chosen:showing_dropdown', function ()
		{
			resizeChosenDropdown.call(this);
		})
		.on('chosen:hiding_dropdown', function ()
		{
			$('body').height(bodyHeight);
			$(window).resize();
		});
}

let xhr;
let autocompleteInput = $('#autocomplete');
autocompleteInput.on('input',
	debounce(() => doneTyping(autocompleteInput.val()), 650)
);

$(document).on('click', function (e) {
	if ($(e.target).closest('.pac-container').length === 0) {
		$('.pac-container').hide();
	}
});

let position = autocompleteInput.position();

function doneTyping(value) {
	if (value.trim().length < 3) {
		return;
	}

	const blz = FF.companyNumber || '10000000';
	//console.log('autocomplete blz: ' + blz);

	$.ajax({
		url: 'https://api.production.cloudios.flowfact-prod.cloud/google-maps-service/public/autocomplete?input=' + value + '&blz=' + blz,
		dataType: 'json',
		crossOrigin: true,
		headers: {
			'accept': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		success: function (response) {
			buildList(response.entries, value);
			getPlaceDetails();
		}
	});
}

function buildList(entries, input) {
	$('.pac-container.pac-logo.hdpi').remove();
	let pacContainer = document.createElement('div');
	pacContainer.setAttribute('class', 'pac-container pac-logo hdpi');
	entries.map(entry => {
		let pacItem = document.createElement('div');
		pacItem.setAttribute('class', 'pac-item');
		pacItem.setAttribute('id', entry.placeId);
		pacContainer.appendChild(pacItem);

		let pacIcon = document.createElement('span');
		pacIcon.setAttribute('class', 'pac-icon pac-icon-marker');
		pacItem.appendChild(pacIcon);

		let pacItemQuery = document.createElement('span');
		pacItemQuery.setAttribute('class', 'pac-item-query');
		pacItem.appendChild(pacItemQuery);

		let pacItemCity = document.createElement('span');
		pacItemCity.textContent = entry.city || '';
		pacItemQuery.appendChild(pacItemCity);

		let pacItemCountry = document.createElement('span');
		pacItemCountry.textContent = entry.country || '';
		pacItem.appendChild(pacItemCountry);
	});
	document.getElementById('locationField_autocomplete_wrapper').appendChild(pacContainer);
}

function getPlaceDetails() {
	$('.pac-item').on('click', function () {
		const blz = FF.companyNumber || '10000000';
		//console.log('place details blz: ' + blz);
		if (xhr) {
			xhr.abort();
		}
		$('.pac-container').hide();
		let placeId = $(this).attr('id');
		let valueForInput = $.map($(this).first().children(), child => $(child).text().trim()).filter(Boolean).join(', ');
		$('#autocomplete').val(valueForInput);
		xhr = $.ajax({
			url: 'https://api.production.cloudios.flowfact-prod.cloud/google-maps-service/public/place-details?placeId=' + placeId + '&blz=' + blz,
			dataType: 'json',
			crossOrigin: true,
			headers: {
				'accept': 'application/json',
				'Access-Control-Allow-Origin': '*'
			},
			success: function (response) {
				document.getElementById('lat').value = response.lat;
				document.getElementById('lng').value = response.long;

				let event = document.createEvent('HTMLEvents'),
					latField = document.getElementById('lat');
				event.initEvent('change', true, false);
				latField.dispatchEvent(event);
			}
		});
	});
}

// ...and with this button user can make those filters (in-)visible
$filterBtn.click(openOrCloseExtendedSearchCriterias);

//And once at the beginning initialize the extended search
$estateTypeSelect.trigger("change");

if ($filterBtn.is(":visible") && window.location.href.match(/[?&](?!schema|minPrice|maxPrice|zipTown|radius|order|lat|lng)([^=]+)=[^&#]+/))
{
	$filterBtn.trigger("click");
}

$search.submit(function (e)
{
	e.preventDefault();
	$.ajax({
		type: "POST",
		url: 'https://api.production.cloudios.flowfact-prod.cloud/google-maps-service/public/temporary/statistics/search',
		crossOrigin: true,
		headers: {
			'accept': 'application/json',
			'Access-Control-Allow-Origin': '*'
		}
	});
	const selectFields   = $(this).find('select[name]'),
		  inputFields    = $(this).find('input[name]'),
		  $priceFields   = $("#price-interval_from:enabled, #price-interval_to:enabled"),
		  disabledFields = [];

	// Disable all fields which are not relevant for the search
	selectFields.each(function ()
	{
		// If the field is already disabled there is no reason to disable it again
		if ($(this).prop('disabled'))
		{
			return;
		}

		const $field         = $(this),
			  fieldId        = $field.attr("id"),
			  $wrapperDiv	 = $("#" + fieldId + "-wrapper");
		
		// Disable all fields, which are hidden or empty
		if ($field.val() === '' || $wrapperDiv.is(':hidden'))
		{
			$field.prop('disabled', true);
			disabledFields.push(fieldId);
		}
	});
	inputFields.each(function ()
	{
		// If the field is already disabled there is no reason to disable it again
		if ($(this).prop('disabled'))
		{
			return;
		}

		const $field         = $(this),
			  fieldId        = $field.attr("id");

		// Disable all fields, which are not visible but also not hidden, or empty
		if ((!$field.is(':visible') && !$field.is('[type="hidden"]')) || $field.val() === '')
		{
			$field.prop('disabled', true);
			disabledFields.push(fieldId);
		}
	});

	$priceFields.each(function ()
	{
		$(this).val(germanCurrencyFormatToCurrency($(this).val()));
	});

	window.ET_Event && ET_Event.click('Immobilien | Suche | Klick_Suche');

	this.submit();

	if ($search[0].target === '_blank')
	{
		//Put this code to the end fo the process queue, so the submit is done before this code gets executed
		setTimeout(() =>
		{
			for (let disabledField of disabledFields)
			{
				$('#' + disabledField).prop('disabled', false);
			}
			$priceFields.each(function ()
			{
				$(this).val(currencyToGermanCurrencyFormat($(this).val()));
			});
		}, 0);
	}
});

$searchResetButton.click(resetAndTriggerSearch);

$('#dropdown-sort').change(function ()
{
	$search.find('#search-order-field').val($(this).val());
	$search.submit();
});

const $locationFields  = $('#lat, #lng, #autocomplete'),
	  $latField        = $locationFields.filter('#lat'),
	  $lngField        = $locationFields.filter('#lng'),
	  $areaSize        = $('#search-first-row').find('#area-size');

function updateLocation()
{
	$latField.val('');
	$lngField.val('');
	$latField.trigger('change');
}

$locationFields.on('input', updateLocation);

$locationFields.keypress(function (e)
{
	if (e.which === 13)
	{
		updateLocation();

		// Preventing 'Enter' Key from triggering form submit, otherwise lat / lng are not filled correctly.
		return false;
	}
});

$latField.on('change', function ()
{
	if ($(this).val())
	{
		//console.log('remove');
		$areaSize.removeAttr('disabled').val(25).trigger('change');
		$areaSize.closest('.select-box').removeClass('select-box--disabled');
	}
	else
	{
		//console.log('add');
		$areaSize.attr('disabled', 'disabled').val('').trigger('change');
		$areaSize.closest('.select-box').addClass('select-box--disabled');
	}

	$areaSize.trigger("chosen:updated");
});

const $saveSearchDialog = $('#savesearch-box');

function openSearchAgentDialog()
{
	$saveSearchDialog.removeClass('hidden');
	resizeFrameForDialog($saveSearchDialog);

	// blur background
	$('.overlay-blur').removeClass('hidden');
	$(document.body).addClass('noscroll');
}

function closeDialog(dialog = {})
{
	const $box  = $(this).closest('.overlay-box').length > 0 ? $(this).closest('.overlay-box') : dialog,
		  $form = $box.find('form');

	//Check if the given object is really a dialog
	if (!$box instanceof jQuery || !$box.hasClass('overlay-box'))
	{
		return;
	}

	$box.addClass('hidden');
	$(document.body).removeClass('noscroll');
	$box.find('.success').addClass('hidden');
	$box.find('.error').addClass('hidden');
	$('.overlay-blur').addClass('hidden');
	$box.find('.info').removeClass('hidden');
	if ($form.length)
	{
		$form.removeClass('hidden');
		$form[0].reset();
	}
	resizeFrameForDialog($box);
}

function resizeFrameForDialog($dialog = {})
{
	const $box  = $(this).closest('.overlay-box').length > 0 ? $(this).closest('.overlay-box') : $dialog,
		  $body = $(document.body);

	//Check if the given object is really a dialog
	if (!$box instanceof jQuery || !$box.is('.overlay-box'))
	{
		return;
	}

	//Make sure the body has its "natural" height to determine whether or not a resize is necessary
	let $bodyStylesWithoutHeight = $body.attr('style');

	if ($bodyStylesWithoutHeight)
	{
		$bodyStylesWithoutHeight = $bodyStylesWithoutHeight.replace(/(?:max-)?height:(?: )*\d+.{0,3};?/g, '');
		if ($bodyStylesWithoutHeight !== '')
		{
			$body.attr('style', $bodyStylesWithoutHeight);
		}
		else
		{
			$body.removeAttr('style');
		}
	}

	if (!$box.is(':visible'))
	{
		//In case the body was resized it should be resettet
		$(window).resize();
		return;
	}

	//Calculate the maximum height from the dialog in relation to the body height
	let maxHeight        = $box.css('max-height'),
		maxHeightAsFloat = 1;

	//If the max-height is given in percent we have to consider it
	if (maxHeight.indexOf('%') > 0)
	{
		maxHeight = maxHeight.replace('%', '');
		if ($.isNumeric(maxHeight) && maxHeight !== '0')
		{
			maxHeight        = Number(maxHeight);
			maxHeightAsFloat = maxHeight / 100;
		}
	}

	//Set the dialog box to its "natural" height, so we can see if it fits in the body
	$box.css({
		'max-height': 'none',
		'height': 'auto'
	});

	//Calculate the space needed for the dialog box to be shown in its full size
	const dialogMaxY = Math.ceil(($box.outerHeight() + $box.offset().top + 1) / maxHeightAsFloat);

	//Remove the dialog boxes "natural" height settings, so its shown as wanted
	$box.removeAttr('style');

	//If the needed height is bigger than the "natural" height of the body resize
	if (dialogMaxY > $body.innerHeight())
	{
		$body.innerHeight(dialogMaxY);
		$(window).resize();
	}
}

function sendSaveSearchRequest()
{
	const $box            = $saveSearchDialog,
		  form            = $box.find('form'),
		  successMessage  = $box.find('.success'),
		  errorMessage    = $box.find('.error'),
		  infoMessage     = $box.find('.info'),
		  params          = form.data('params'),
		  email           = form.find('[name=email]').val(),
		  isNotValidEmail = !(/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email)),
		  isNotAgbChecked = !form.find('#agbCheck').is(':checked'),
		  $blur           = $('.overlay-blur'),
		  origzindex      = $blur.css('z-index');

	if (isNotValidEmail)
	{
		errorMessage.text('Bitte geben Sie eine gültige E-Mailadresse an.').removeClass('hidden');
		resizeFrameForDialog($box);
		return;
	}

	if (isNotAgbChecked)
	{
		errorMessage.text('Bitte bestätigen Sie unsere Bedingungen und Hinweise.').removeClass('hidden');
		resizeFrameForDialog($box);
		return;
	}

	// Resetting error message
	errorMessage.text('Leider konnte aus technischen Gründen Ihre E-Mail-Benachrichtigung nicht eingerichtet werden. Bitte versuchen Sie es später noch einmal.').addClass('hidden');

	// Adding email to data which will be sent to server for further processing
	params.email = email;

	$blur.css('z-index', '5');
	$('.please-wait').removeClass('hidden');

	$.ajax({
		url: FF.baseUrl + 'index.php/platformApi/saveSearch',
		type: 'POST',
		data: params,
		dataType: 'json'
	}).always(function ()
	{
		$blur.css('z-index', origzindex);
		$('.please-wait').addClass('hidden');
	}).done(function (data)
	{
		if (data.success)
		{
			successMessage.removeClass('hidden');
			form.addClass('hidden');
			infoMessage.addClass('hidden');
			errorMessage.addClass('hidden');
		}
		else
		{
			successMessage.addClass('hidden');
			if (data.reason)
			{
				errorMessage.text = data.reason;
			}
			errorMessage.removeClass('hidden');
		}
		resizeFrameForDialog($box);
	}).fail(function ()
	{
		successMessage.addClass('hidden');
		errorMessage.removeClass('hidden');
		resizeFrameForDialog($box);
	});

}

//The search-agent-open-button also appears on the estate result now, so do not change the selector to
// $search.find('.search-agent-open-button') again please
$('.search-agent-open-button').click(openSearchAgentDialog);
$saveSearchDialog.find('.button.close').click(closeDialog);
$saveSearchDialog.find('form').submit(sendSaveSearchRequest);

$('.estate-link-button').click(function ()
{
	const $estate   = $(this).closest('.estate'),
		  tradeType = $estate.data('trade-type'),
		  bankName  = $estate.data('bank-name');

	if (tradeType && bankName)
	{
		ET_Event.click(`Immobilien | Lead Bankueberleitung | ${tradeType === 'RENT' ? 'Miet' : 'Kauf'}suche | ${bankName}`);
	}

	$.ajax({
		url: FF.makeCompanyUrl('index.php/api/raiseRedirection'),
		type: 'PUT'
	});
});
